import { environment } from '@src/environments/environment';
import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';

const secureRoutes = [environment.baseUrl];
const ecoembes = environment.ecoembesAuth;

// PBI-866415: Retirados customParamsAuthRequest (resource, opcion=sinregistro).
// El scope viene de environment.ecoembesAuth.scope y no debe contener allatclaims.
// El scope incluye offline_access (habilitado por el admin del tenant CIAM),
// así que la librería obtiene refresh_token y hace renovación silenciosa
// automática — sin necesidad de silentRenewUrl con iframe HTML dedicado.
//
// PBI-877361: parámetros de vigencia y renovación de token.
// ignoreNonceAfterRefresh: Entra External ID reenvía en el id_token de cada
// refresh el mismo 'nonce' del login original. La librería espera que tras un
// refresh el id_token venga sin nonce, así que rechazaba las renovaciones
// ("authCallback incorrect nonce"), borraba los tokens y el usuario perdía la
// sesión al caducar el primer id_token (~1h). Solo afecta a la validación tras
// un refresh: el nonce del login inicial se sigue validando.
// maxIdTokenIatOffsetAllowedInSeconds: tolerancia entre el 'iat' del id_token y
// el reloj local. Entra emite el 'iat' retrasado ~5 min (300s) respecto a la
// emisión real, así que cualquier valor <= 300 rechaza SIEMPRE el login inicial
// (MaxOffsetExpired). 600s = 300s de retraso de Entra + 300s de desfase de reloj.
// Sigue siendo mucho más estricto que el parche previo de 3600s.
// renewTimeBeforeTokenExpiresInSeconds: renueva 5 min antes de que caduque el
// token para evitar 401 por relojes desajustados, pestañas en segundo plano o
// reintentos de red. Debe ser menor que la vida del access token del tenant.
// El `exp` del token se sigue validando estrictamente.
export const authConfigs: OpenIdConfiguration[] = [
  {
    configId: 'ecoembes',
    authority: ecoembes.authority,
    redirectUrl: window.location.origin + '/callback',
    postLogoutRedirectUri: window.location.origin,
    clientId: ecoembes.clientId,
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 300,
    triggerRefreshWhenIdTokenExpired: true,
    ignoreNonceAfterRefresh: true,
    maxIdTokenIatOffsetAllowedInSeconds: 600,
    logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
    scope: ecoembes.scope,
    disablePkce: false,
    autoUserInfo: false,
    secureRoutes,
  },
];
